/**
 * External dependencies.
 */
import { store, getElement } from '@wordpress/interactivity';

store('rothschild-events/date-filter', {
  actions: {
    /**
     * Update page url.
     */
    *navigate() {
      const { ref } = getElement();
      const { actions } = yield import('@wordpress/interactivity-router');
      const url = new URL(ref?.closest('form.wp-block-rothschild-events-date-filter')?.action);

      if (!new Date(ref?.value)?.valueOf()) {
        url?.searchParams.delete(ref?.name);
      } else {
        url?.searchParams.set(ref?.name, ref?.value);
      }

      yield actions.navigate(url?.toString());
    },
  },
});
